export const webappABTestServiceReady = new Promise(resolve => {
  if (window.webappCompatABTest) {
    resolve();
  } else {
    window.webappCompatABTestReadyCallback = () => resolve();
  }
});

export const ABTest = {
  // returns a Promise of the variation name, based on the experiment name and
  // the user's current tracking session ID.
  getSessionExperimentVariation(experimentName) {
    return webappABTestServiceReady.then(() =>
      window.webappCompatABTest.getSessionExperimentVariation(experimentName),
    );
  },
  // returns a Promise of the variation name, based on the experiment name and
  // an optional user id. If the user id is not specify, it falls back to using
  // the user's current ID (we run tests based on other users' IDs, e.g.
  // project owners IDs).
  getUserExperimentVariation(experimentName, userId) {
    return webappABTestServiceReady.then(() =>
      window.webappCompatABTest.getUserExperimentVariation(
        experimentName,
        userId,
      ),
    );
  },
  // returns a Promise of the variation name, based on the experiment name and
  // a project ID.
  getProjectExperimentVariation(experimentName, projectId) {
    return webappABTestServiceReady.then(() =>
      window.webappCompatABTest.getProjectExperimentVariation(
        experimentName,
        projectId,
      ),
    );
  },
};
